export default __webpack_public_path__ + "static/media/phoneLogo.1497a6fb.svg";